var render = function render(){var _vm=this,_c=_vm._self._c;return _c('tr',{staticClass:"d-flex table-row",class:[
    { removeCursor: _vm.removeCursor, active: _vm.active, hovering: _vm.hovering, selected: _vm.selected, nonSelected: !_vm.selected },
  ]},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }